import api from "../api";

// User: Webhook Logs
export const getMyWebhookLogs = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "webhook-logs", { params });
};

export const getWebhookLog = async (id) => {
  return api.getApi().get(api.getBaseUrl() + `webhook-logs/${id}`);
};

export const getWebhookStats = async () => {
  return api.getApi().get(api.getBaseUrl() + "webhook-logs/stats");
};

// Admin: Webhook Logs
export const getAllWebhookLogs = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "admin/webhook-logs", { params });
};

